import { getAiBuilding } from '@/api/aiBuilding/aiBuildingApiGwFuncs'
import { ERROR_CODES } from '@/constants/error/errorCode'
import type { ArgGetItemAiBuilding, ResGetItemAiBuilding } from '@/types/api/aiBuilding/aiBuilding'
import { GlobalError } from '@/utils/globalError/globalError'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAiBuildingStore = defineStore('aiBuilding', () => {
  /** AI倒壊判定結果 */
  const aiBuildingResult = ref<ResGetItemAiBuilding['result'] | null>(null)

  /**
   * AI倒壊判定結果取得
   * @param params 実際のAPIパラメータ
   * @returns なし
   */
  const fetchAndSetAiBuildingResult = async (params: ArgGetItemAiBuilding): Promise<void> => {
    try {
      const res = await getAiBuilding(params)
      aiBuildingResult.value = res.result
    } catch (err) {
      console.error(err)
      throw new GlobalError([ERROR_CODES.AI_BUILDING_INFO_FETCH_FAILED])
    }
  }

  /**
   * stateを初期化
   * @param なし
   * @returns なし
   */
  const reset = (): void => {
    aiBuildingResult.value = null
  }

  return {
    aiBuildingResult,
    fetchAndSetAiBuildingResult,
    reset
  }
})
